exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidebarContent .el-loading-mask {\n  background: #fff !important;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.sidebarContent .el-loading-mask .el-loading-spinner {\n  position: relative;\n  margin-top: 0;\n  top: 0;\n}\n", ""]);

// exports
